import { type FeatureFlags } from 'HOOKS/useFeatureFlags/components/FeatureFlagsProvider/FeatureFlagsProvider'
import type { FeatureFlagResponse } from 'TYPES/api'

export const convertFeatureFlagResponseToFeatureFlagObject = (
  featureFlags: FeatureFlagResponse[],
): FeatureFlags => {
  return featureFlags.reduce<FeatureFlags>((acc, featureFlag) => {
    acc[featureFlag.id ?? featureFlag.description ?? ''] = featureFlag
    return acc
  }, {})
}
